// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u012x7{margin-left:var(--ds-space-075,6px)}", ""]);
// Exports
module.exports = exports;
